export default __webpack_public_path__ + "static/media/GstOptionScreen.5386681d.png";